import LogOutIcon from "@icons/logout.svg";
import { Dialog } from "@mui/material";
import Colors from "@constants/Colors";
import {
  CustomButtonLogOut,
  LogOutButtonWrapper,
  LogOutModalWrapper,
  LogOutTextWrapper,
  StyledIcon,
} from "./styles";

interface LogOutModalProps {
  open: boolean;
  onHandleClose: () => void;
  onHandleLogout: () => void;
}

const LogOutModal = (props: LogOutModalProps) => {
  const { open, onHandleClose, onHandleLogout } = props;

  return (
    <Dialog onClose={onHandleClose} open={open}>
      <LogOutModalWrapper>
        <StyledIcon src={LogOutIcon} alt="" />
        <LogOutTextWrapper>
          Are you sure you want to log
          <br /> out of your account?
        </LogOutTextWrapper>
        <LogOutButtonWrapper>
          <CustomButtonLogOut
            onClick={onHandleClose}
            textColor={Colors.secondary}
            backgroundColor={Colors.neutral_gray_100}
          >
            Cancel
          </CustomButtonLogOut>
          <CustomButtonLogOut
            onClick={onHandleLogout}
            textColor={Colors.white}
            backgroundColor={Colors.secondary}
          >
            Log out
          </CustomButtonLogOut>
        </LogOutButtonWrapper>
      </LogOutModalWrapper>
    </Dialog>
  );
};

export default LogOutModal;
